// extracted by mini-css-extract-plugin
export default {"default":"SortedSelect_default__1Jo_J"};